import React from 'react';

import { Button, Dialog } from '@armis/armis-ui-library';

import {
    BannerContent,
    BannerTitle,
    MessageContainer,
    BannerMessage,
    BulletList,
    BulletItem,
    ButtonWrapper
} from './GovernmentBanner.style';

interface GovernmentBannerProps {
    open: boolean;
    onAccept: () => void;
}

export const GovernmentBanner: React.FC<GovernmentBannerProps> = ({
    open,
    onAccept
}) => (
    <Dialog
        disableEscapeKeyDown
        maxWidth="sm"
        open={open}
    >
        <BannerContent>
            <BannerTitle>Terms of Service</BannerTitle>
            <MessageContainer>
                <BannerMessage>
                    You are accessing a U.S. Government information system which
                    includes:
                </BannerMessage>
                <BulletList>
                    <BulletItem>This computer</BulletItem>
                    <BulletItem>This computer network</BulletItem>
                    <BulletItem>
                        All computers connected to this network
                    </BulletItem>
                    <BulletItem>
                        All devices and storage media attached to this network
                        or to a computer on this network
                    </BulletItem>
                </BulletList>
                <BannerMessage>
                    This information system is provided for U.S.
                    Government-authorized use only. Unauthorized or improper use
                    of this system may result in disciplinary action, and civil
                    and criminal penalties.
                    System usage may be monitored, recorded, and audited.
                </BannerMessage>
            </MessageContainer>
            <ButtonWrapper>
                <Button onClick={onAccept} variant="contained">
                    I Agree
                </Button>
            </ButtonWrapper>
        </BannerContent>
    </Dialog>
);

